// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settingsMain {
  background-color: #07405e;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  position: fixed;
  overflow-y: auto;
}
.settingsMain .settingsContainer {
  height: 85%;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 97%;
  height: 100dvh;
  padding: 10px;
}
@media (min-width: 450px) {
  .settingsMain .settingsContainer {
    width: 400px;
  }
}
@media only screen and (max-height: 712px) {
  .settingsMain .settingsContainer {
    height: 100%;
  }
}
.settingsMain .inputContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.settingsMain .inputContainer .generalLabel {
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-transform: uppercase;
  width: 90%;
}
.settingsMain .inputContainer .inputBlock {
  background-color: rgba(105, 155, 182, 0.4);
  padding: 10px;
  width: 97%;
  position: relative;
}
.settingsMain .inputContainer .nameInput {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.settingsMain .inputContainer .passwordInput {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.settingsMain .inputContainer label {
  color: #699BB6;
  font-family: Arial;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}
.settingsMain .inputContainer .settingsInput {
  width: 100%;
  padding: 10px;
  border: none;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  -webkit-border-bottom-left-radius: 0px;
  -webkit-border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  border: none;
  font-family: Arial;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  color: #FFFFFF;
  background: transparent;
  padding: 0;
  margin: 0;
  border-bottom: 1px solid #699BB6;
}
.settingsMain .inputContainer input:focus {
  outline: none;
}
.settingsMain .inputContainer .custom-switch {
  background-color: #699BB6;
  border: 1px solid #699BB6;
}
.settingsMain .inputContainer .ant-switch-handle {
  top: 0px;
}
.settingsMain .inputContainer .custom-switch.ant-switch-checked {
  background-color: #ff6b6b;
  border: 1px solid #ff6b6b;
}
.settingsMain .inputContainer .custom-switch {
  outline: none;
}
.settingsMain .inputContainer .ant-switch-checked:hover:not(.ant-switch-disabled) {
  background: #ff6b6b;
}
.settingsMain .inputContainer .rounded {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.settingsMain .inputContainer .switchBlock {
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
}
.settingsMain .inputContainer .switchBlock label {
  font-family: Arial;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  color: #FFFFFF;
}
.settingsMain .inputContainer .hissInput, .settingsMain .inputContainer .walletInput, .settingsMain .inputContainer .telegramInput, .settingsMain .inputContainer .informationInput {
  border-radius: 10px;
}
.settingsMain .inputContainer .informationInput {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: Arial;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  color: #FFFFFF;
}
.settingsMain .inputContainer .hissInput {
  margin-top: 65px;
}
.settingsMain .inputContainer .saveBtn {
  height: 38px;
  border-radius: 8px;
  border: 0.8px solid #699BB6;
  background: rgba(255, 255, 255, 0);
  padding: 0px 22px;
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  margin: 30px 0px 30px 0px;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 155%;
  width: 90%;
}
.settingsMain .inputContainer .walletDescription {
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  position: absolute;
  width: 90%;
  left: 12px;
  bottom: -50px;
}
.settingsMain .inputContainer .settingsError {
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
}
.settingsMain .inputContainer .fade-in {
  animation: fadeIn 0.5s;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/settings/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAGA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AADF;AAEE;EAIE,WAAA;EAIA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;AANJ;AANM;EADJ;IAEM,YAAA;EASN;AACF;AAPI;EALF;IAMM,YAAA;EAUN;AACF;AAFE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAIJ;AAHI;EACE,cChCW;EDiCX,iCE7BG;EF8BH,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,UAAA;AAKN;AAHI;EACE,0CAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;AAKN;AAHI;EACE,4BAAA;EACA,6BAAA;AAKN;AAFI;EACE,+BAAA;EACA,gCAAA;AAIN;AAFI;EACE,cCzDW;ED0DX,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAIN;AADI;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,uCAAA;EACA,8BAAA;EACA,+BAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cClFO;EDmFP,uBAAA;EACA,UAAA;EACA,SAAA;EACA,gCAAA;AAGN;AADI;EACE,aAAA;AAGN;AADI;EACE,yBC3FW;ED4FX,yBAAA;AAGN;AADI;EACE,QAAA;AAGN;AADI;EACE,yBAAA;EACA,yBAAA;AAGN;AADI;EACE,aAAA;AAGN;AADI;EACE,mBAAA;AAGN;AADI;EACE,+BAAA;EACA,gCAAA;AAGN;AAAI;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;AAEN;AADM;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cC3HK;AD8Hb;AAAI;EACE,mBAAA;AAEN;AAAI;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cC3IO;AD6Ib;AADI;EACE,gBAAA;AAGN;AADI;EACE,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,kCAAA;EACA,iBAAA;EACA,cCpJW;EDqJX,iCEjJG;EFkJH,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;AAGN;AADI;EACE,cC9JW;ED+JX,iCE3JG;EF4JH,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;AAGN;AADI;EACE,cAAA;EACA,eAAA;EACA,eAAA;AAGN;AADI;EACE,sBAAA;AAGN;AAAI;EACE;IACE,UAAA;IACA,4BAAA;EAEN;EAAI;IACE,UAAA;IACA,wBAAA;EAEN;AACF","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/fonts.scss';\n\n.settingsMain {\n  background-color: #07405e;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  height: 100dvh;\n  position: fixed;\n  overflow-y: auto;\n  .settingsContainer {\n      @media (min-width: 450px){\n        width: 400px;\n    }\n    height: 85%;\n    @media only screen and (max-height: 712px) {\n        height: 100%;\n    }\n    display: flex;\n    align-items: center;  \n    flex-direction: column;\n    width: 97%;\n    height: 100dvh;\n    padding: 10px;\n  }\n  .inputContainer{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    .generalLabel {\n      color: $color-Secondary;\n      font-family: $Roboto;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 18px;\n      text-transform: uppercase;\n      width: 90%;\n    }\n    .inputBlock {\n      background-color: rgba(105, 155, 182, 0.4);\n      padding: 10px;\n      width: 97%;\n      position: relative;\n    }\n    .nameInput {\n      border-top-left-radius: 10px;\n      border-top-right-radius: 10px;\n    }\n  \n    .passwordInput {\n      border-bottom-left-radius: 10px;\n      border-bottom-right-radius: 10px;\n    }\n    label {\n      color: $color-Secondary;\n      font-family: Arial;\n      font-size: 15px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 140%;\n    }\n  \n    .settingsInput {\n      width: 100%;\n      padding: 10px;\n      border: none;\n      border-top-left-radius: 5px;\n      border-top-right-radius: 5px;\n      -webkit-border-bottom-left-radius: 0px;\n      -webkit-border-bottom-right-radius: 0px;\n      border-bottom-left-radius: 0px;\n      border-bottom-right-radius: 0px;\n      border: none;\n      font-family: Arial;\n      font-size: 17px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 140%;\n      color: $color-White;\n      background: transparent;\n      padding: 0;\n      margin: 0;\n      border-bottom: 1px solid $color-Secondary;\n    }\n    input:focus {\n      outline: none;\n    }\n    .custom-switch {\n      background-color: $color-Secondary;\n      border: 1px solid $color-Secondary;\n    }\n    .ant-switch-handle {\n      top: 0px;\n    }\n    .custom-switch.ant-switch-checked {\n      background-color: #ff6b6b;\n      border: 1px solid #ff6b6b;\n    }\n    .custom-switch {\n      outline: none;\n    }\n    .ant-switch-checked:hover:not(.ant-switch-disabled) {\n      background: #ff6b6b;\n    }\n    .rounded{\n      border-bottom-left-radius: 10px;\n      border-bottom-right-radius: 10px;\n      \n    }\n    .switchBlock {\n      display: flex;\n      justify-content: space-between;\n      padding-bottom: 20px;\n      label {\n        font-family: Arial;\n        font-size: 17px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 140%;\n        color: $color-White;\n      }\n    }\n    .hissInput, .walletInput, .telegramInput ,.informationInput {\n      border-radius: 10px;\n    }\n    .informationInput{\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      font-family: Arial;\n      font-size: 17px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 140%;\n      color: $color-White    }\n    .hissInput{\n      margin-top: 65px;\n    }\n    .saveBtn {\n      height: 38px;\n      border-radius: 8px;\n      border: 0.8px solid $color-Secondary;\n      background: rgba(255, 255, 255, 0);\n      padding: 0px 22px;\n      color: $color-Secondary;\n      font-family: $Roboto;\n      margin: 30px 0px 30px 0px;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 155%;\n      width: 90%;\n    }\n    .walletDescription {\n      color: $color-Secondary;\n      font-family: $Roboto;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 18px;\n      position: absolute;\n      width: 90%;\n      left: 12px;\n      bottom: -50px;\n    }\n    .settingsError {\n      color: #ff4d4f; // Ant Design error color\n      font-size: 12px;\n      margin-top: 4px;\n    }\n    .fade-in {\n      animation: fadeIn 0.5s;\n    }\n    \n    @keyframes fadeIn {\n      0% {\n        opacity: 0;\n        transform: translateY(-10px);\n      }\n      100% {\n        opacity: 1;\n        transform: translateY(0);\n      }\n\n    }\n  }\n}\n","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
